import { TrackListItem } from "./TrackListItem";

import * as styles  from "./styles.module.scss";

export const TrackList = ({ tracks, current }) => {
    const onSelect = (number) => {
        window.audioplayer.find(number);
    };

    return (
        <ul className={styles.list}>
            {tracks.map((track) => (
                <li key={track.number} className={styles.item}>
                    <TrackListItem
                        track={track}
                        current={track.number === current}
                        onSelect={() => onSelect(track.number)}
                    />
                </li>
            ))}
        </ul>
    );
};
